import { create } from "zustand";
import { TAB_IDS, type TabId } from "@empire/shared";

/**
 * The Village tab holds two screens: the village itself and the defence editor
 * it opens (S07). They are one tab rather than two because the editor is a
 * thing you go INTO from your village and come back out of — 03 §5 — and a
 * sixth tab for it would say the opposite.
 */
export type VillageView = "village" | "defence";

/** The account sheet (D-116): save this village, or log in to a saved one. */
export type AccountSheetMode = "save" | "login";

interface UiState {
  tab: TabId;
  villageView: VillageView;
  account: AccountSheetMode | null;
  setTab: (tab: TabId) => void;
  setVillageView: (view: VillageView) => void;
  openAccount: (mode: AccountSheetMode | null) => void;
}

export const useUiStore = create<UiState>((set) => ({
  tab: TAB_IDS[0],
  villageView: "village",
  account: null,
  openAccount: (account) => set({ account }),
  setTab: (tab) => set({ tab }),
  setVillageView: (villageView) => set({ villageView }),
}));
